module.exports = __webpack_public_path__ + "static/media/g6.7ef47c4b.jpg";